/**
 * Created by ronmarsiano on 25/11/2018.
 */
mainApp.component('socketUnassign', {
    templateUrl: '/public/components/socket-unassign.component.html',
    bindings: {
        socketSettings: '=',
        siteName: '=',
        showUnassignButton: '<',
    },
    controller: socketUnassignController
});


function socketUnassignController($scope, CopyToClipboardService, SocketUIService, $state, UserContextService) {

    let ctrl = this;
    ctrl.isEditor = UserContextService.isEditor();

    ctrl.onClick = function () {

        ctrl.warningMessage = getWarningMessage();
        ctrl.implicationMessage = getImplicationMessage();

        $scope.$root.openPopup('socketUnassignDlg' + '-' + ctrl.socketSettings.id);
    };

    /**
     * adress the server to unassign the selected socket
     */
    ctrl.unassignSocket = function () {

        let path = ctrl.socketSettings.type.value === 'AWS' || ctrl.socketSettings.type.value === 'AZURE' ? '/removeVSocket' : '/unassignSocket';

        store.save({
            path: path,
            method: 'POST',
            queryParams: { socketId: ctrl.socketSettings.id},
            success: function (data) {
                if(data && data.status && data.status == "ERROR"){
                    let unassignErrors = data.notifications.filter(error => error.field === 'unassignSocketError');
                    if (unassignErrors){
                        let error = unassignErrors.pop();
                        $scope.$root.errors[error.field] = error.message;
                    } else {
                        $scope.$root.errors['unassignSocketError'] = 'Could not unassign socket';
                    }
                }
                else{
                    let args = {};
                    // broadcast an event so the sitesCtrl could reload
                    $scope.$root.$broadcast('unassignSocketOrSocketAdditionEvent', args);
                    $scope.$root.closePopup('socketUnassignDlg' + '-' + ctrl.socketSettings.id);
                }
                $scope.$digest();
            },
            error: function (error) {
                $scope.$root.errors['unassignSocketError'] = 'Could not unassign socket';
                $scope.$digest();
            }
        });
    };

    /**
     * close the dialog , remove error message if one exsists \
     * delete selected socket settings
     */
    ctrl.closeDlg = function () {
        delete $scope.$root.errors['unassignSocketError'];
        $scope.$root.closePopup('socketUnassignDlg' + '-' + ctrl.socketSettings.id);
    };

    ctrl.copySerial = function(serialToCopy) {
        CopyToClipboardService.copy(serialToCopy);
    }

    let getWarningMessage = function () {

        let suffix = (ctrl.socketSettings.type.value === 'AWS') ? "and disable High-Availability mode for this site." : "and revert it to it's factory default state" ;

        let message = `You are about to unassign Socket S/N: ${ctrl.socketSettings.socketID} \n` +
                      `from the site ${ctrl.siteName} ${suffix}`

        return message;
    }

    let getImplicationMessage = function () {
        return `You can’t undo this operation, and vSocket ${ctrl.socketSettings.socketID} won’t be able to connect to Cato.`
    }

    ctrl.openSocketUI = (socketDeviceId) => {
        return SocketUIService.openSocketUI(socketDeviceId,$state.params.accountId);
    }
}
